import * as api from '../../services/invitation'

export const FETCH_INVITATIONS= 'FETCH_INVITATIONS';
export const FETCH_INVITATION = 'FETCH_INVITATION';


export const fetchInvitation = (eventId,inviteeId) => ({
        type: FETCH_INVITATION,
        payload: {
            promise: api.findInvitation({eventId:eventId,inviteeId: inviteeId})
        }

});


export const fetchInvitations = (params, pagination, sort, extra) => {

    return {
        type: FETCH_INVITATIONS,
        payload: {
            promise: api.findInvitations(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/invitation.js